export default __webpack_public_path__ + "static/media/membre_chahinez.83e274dd.JPG";